import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import HomeBannerData from "../../components/admincomponents/HomeBannerData";
import ContractorPageManage from "../../components/admincomponents/ContractorPageManage";

function ContractorPageBannerData({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <ContractorPageManage />            
    </>
  );
}

export default ContractorPageBannerData;
